import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FutureReadyAvIntegration from "./sections/FutureReadyAvIntegration";
import TheTurnkeyAdvantage from "./sections/TheTurnkeyAdvantage";
import OurPrintSolutions from "./sections/OurPrintSolutions";
import SpecializedDesignExpertise from "./sections/SpecializedDesignExpertise";
import IndustrySolutionsGallery from "./sections/IndustrySolutionsGallery";
import AIModels from "./sections/AIModels";
import StartYourIntegration from "./sections/StartYourIntegration";
import FooterArchive from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FutureReadyAvIntegration />
      <TheTurnkeyAdvantage />
      <OurPrintSolutions />
      <SpecializedDesignExpertise />
      <IndustrySolutionsGallery />
      <AIModels />
      <StartYourIntegration />
      <FooterArchive />
    </div>;
}